/**
 * Globalna TanStack React Query instanca sa podrazumevanim cache i staleTime opcijama.
 * Deljeni queryClient omogućava deduplikaciju in-flight zahteva i keširanje između komponenti.
 */

import { QueryClient } from '@tanstack/react-query';

/** Podrazumevani staleTime: 2 minuta — isti queryKey deli jedan in-flight zahtev i keš do background refetch-a. */
const STALE_TIME_MS = 2 * 60 * 1000;
/** Vreme zadržavanja neaktivnog keša pre garbage collection-a. */
const CACHE_TIME_MS = 5 * 60 * 1000;

/**
 * Singleton QueryClient sa globalnim default opcijama za sve query-je.
 * @type {import('@tanstack/react-query').QueryClient}
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      gcTime: CACHE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
